<template>
  <v-dialog ref="dialog" v-model="show" persistent width="700px">
    <v-card>
      <v-card-title
        >Legend<v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeHelpEvent">
          Close
        </v-btn></v-card-title
      >
      <v-card-text>
        <p v-if="tracks.length == 0 && maps.length == 0">
          There is no visible metadata.
        </p>
        <v-row no-gutters>
          <v-col v-if="tracks.length">
            <h3>Tracks</h3>
            <div v-for="t in tracks" :key="t.idx" class="ml-5 mt-5">
              <h4>{{ t.label }}</h4>
              <v-row v-for="c in t.categories" :key="c.label" no-gutters>
                <v-col v-if="c.style['fill-opacity'] > 0">
                  <Category-Legend :category="c"> </Category-Legend>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <!-- Correspondence between colors and sequence conservation levels:
        <v-row v-for="c in getConservationCategories" :key="c.label" no-gutters>
          <v-col>
            <v-btn x-small rounded :color="c.style.fill" class="metadata-btn"></v-btn>
            {{ c.label }}</v-col
          >
        </v-row> -->
          <v-col v-if="maps.length">
            <h3>Mappings</h3>
            <div v-for="t in maps" :key="t.idx" class="ml-5 mt-5">
              <h4>{{ t.label }}</h4>
              <v-row v-for="c in t.categories" :key="c.label" no-gutters>
                <v-col v-if="c.style['fill-opacity'] > 0">
                  <Category-Legend :category="c"> </Category-Legend>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col v-if="glyphs.length">
            <h3>Glyphs</h3>
            <div v-for="t in glyphs" :key="t.idx" class="ml-5 mt-5">
              <h4>{{ t.label }}</h4>
              <v-row v-for="c in t.categories" :key="c.label" no-gutters>
                <v-col v-if="c.style['fill-opacity'] > 0">
                  <Category-Legend :category="c"> </Category-Legend>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CategoryLegend from '@/components/help/CategoryLegend.vue';

export default {
  components: {
    CategoryLegend,
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    metadata: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    tracks() {
      return this.metadata
        .filter(m => m.track)
        .filter(m => {
          return m.categories.some(c => {
            return c.style['fill-opacity'] > 0;
          });
        });
    },
    maps() {
      return this.metadata
        .filter(m => m.map)
        .filter(m => {
          return m.categories.some(c => {
            return c.style['fill-opacity'] > 0;
          });
        });
    },
    glyphs() {
      return this.metadata
        .filter(m => m.glyph)
        .filter(m => {
          return m.categories.some(c => {
            return c.style['fill-opacity'] > 0;
          });
        });
    },
  },
  methods: {
    closeHelpEvent() {
      this.$emit('hide');
    },
  },
};
</script>

<style></style>
